import { render, staticRenderFns } from "./HosDetaile.vue?vue&type=template&id=c7431e20&scoped=true"
import script from "./HosDetaile.vue?vue&type=script&lang=js"
export * from "./HosDetaile.vue?vue&type=script&lang=js"
import style0 from "./HosDetaile.vue?vue&type=style&index=0&id=c7431e20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7431e20",
  null
  
)

export default component.exports